/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PreviewRoleRequest
 */
export interface PreviewRoleRequest {
    /**
     * The organisation the admin user wants to preview the role as
     * @type {string}
     * @memberof PreviewRoleRequest
     */
    organisationId?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof PreviewRoleRequest
     */
    permissions?: Array<PreviewRoleRequestPermissionsEnum>;
}

/**
 * @export
 */
export const PreviewRoleRequestPermissionsEnum = {
    None: "none",
    DeviceLocationRead: "device_location_read",
    DeviceLocationUpdate: "device_location_update",
    DeviceConfigRead: "device_config_read",
    DeviceConfigUpdate: "device_config_update",
    DeviceReset: "device_reset",
    DeviceLogsRead: "device_logs_read",
    DeviceTasksRead: "device_tasks_read",
    DeviceTasksCreate: "device_tasks_create",
    DeviceEnergyUsageRead: "device_energy_usage_read",
    DeviceOperationalUpdate: "device_operational_update",
    DeviceFirmwareUpdate: "device_firmware_update",
    ChargeTransactionsRead: "charge_transactions_read",
    PowerMeterValuesRead: "power_meter_values_read",
    UserTasksRead: "user_tasks_read",
    EnterpriseUserAccountRead: "enterprise_user_account_read",
    EnterpriseUserAccountUpdate: "enterprise_user_account_update",
    EnterpriseUserAccountRoleUpdate: "enterprise_user_account_role_update",
    DeviceGroupManage: "device_group_manage",
    DeviceGroupCreate: "device_group_create",
    DeviceProvisioning: "device_provisioning",
    DevicePassthroughManage: "device_passthrough_manage",
    RfidTagsRead: "rfid_tags_read",
    RfidTagsManage: "rfid_tags_manage",
    RfidTagsDelete: "rfid_tags_delete",
    RoleCreate: "role_create",
    TicketingRead: "ticketing_read",
    TicketingCreate: "ticketing_create",
    PpmRead: "ppm_read",
    PpmManage: "ppm_manage",
    WebhookCreate: "webhook_create",
    NotificationPreferencesRead: "notification_preferences_read",
    NotificationPreferencesManage: "notification_preferences_manage",
    NotificationPreferencesManageOthers:
        "notification_preferences_manage_others",
    OrganisationPreferencesManage: "organisation_preferences_manage",
    MediaManage: "media_manage",
    DnspDashboard: "dnsp_dashboard",
    ProjectDashboard: "project_dashboard",
    GlobalDashboard: "global_dashboard",
    SystemDeviceProvisioning: "system_device_provisioning",
    SystemDeviceDeprovisioning: "system_device_deprovisioning",
    SystemDeviceAccessTagsUpdate: "system_device_access_tags_update",
    SystemDeviceServiceManage: "system_device_service_manage",
    SystemDeviceCatalogueUpdate: "system_device_catalogue_update",
    SystemOrganisation: "system_organisation",
    SystemUserAccountManage: "system_user_account_manage",
    SystemRfidTagsManage: "system_rfid_tags_manage",
    SystemPassthroughManage: "system_passthrough_manage",
    SystemServiceModelManage: "system_service_model_manage",
    SystemVehicleModelManage: "system_vehicle_model_manage",
    DevicePricingRead: "device_pricing_read",
    DevicePricingManage: "device_pricing_manage",
    DeviceDisplayPriceRead: "device_display_price_read",
    DeviceDisplayPriceManage: "device_display_price_manage",
    PartnerDeviceProvisioning: "partner_device_provisioning",
    PartnerOrganisationManage: "partner_organisation_manage",
    SystemE2eTestRunner: "system_e2e_test_runner",
} as const;
export type PreviewRoleRequestPermissionsEnum =
    (typeof PreviewRoleRequestPermissionsEnum)[keyof typeof PreviewRoleRequestPermissionsEnum];

/**
 * Check if a given object implements the PreviewRoleRequest interface.
 */
export function instanceOfPreviewRoleRequest(
    value: object,
): value is PreviewRoleRequest {
    return true;
}

export function PreviewRoleRequestFromJSON(json: any): PreviewRoleRequest {
    return PreviewRoleRequestFromJSONTyped(json, false);
}

export function PreviewRoleRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PreviewRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        permissions:
            json["permissions"] == null ? undefined : json["permissions"],
    };
}

export function PreviewRoleRequestToJSON(
    value?: PreviewRoleRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        organisationId: value["organisationId"],
        permissions: value["permissions"],
    };
}
